import {
    getCostsByLevels,
    getCostsCharts,
    getCostsComparison,
} from "@/api/financialReport";
import { createReportModule } from "./utils/createReportModule";

// Cuentas level_2 cuya suma forma el numerador del ratio "% Costos / Ventas".
// Coincide con el cálculo de Margen Bruto en el Estado de Resultados
// (ventas_netas - costos_directos), expresado acá como costos / ventas.
const COST_RATIO_L2_ACCOUNTS = [
    "Costos de Productos",
    "Costos Variables",
    "Costos Fijos",
    "Costos Directos",
];

// Reporte de Costos (tabla de evolución + gráficos + comparación + summary).
// Espejo de expensesReport; toda la mecánica vive en createReportModule.
export default createReportModule({
    apiFns: {
        byLevels: getCostsByLevels,
        charts: getCostsCharts,
        comparison: getCostsComparison,
    },
    ratioL2Accounts: COST_RATIO_L2_ACCOUNTS,
    ratioLabel: "% Costos / Ventas",
    totalLabel: "Costos Totales",
    fetchActionNames: {
        data: "fetchCostsData",
        charts: "fetchCostsCharts",
        comparison: "fetchCostsComparison",
    },
    logPrefix: "[costsReport]",
    errorMessages: {
        data: "Error al cargar costos.",
        charts: "Error al cargar gráficos de costos.",
    },
});
